/** Bill wise allocation (screen 188): invoice row + unregistered receipt grid helpers. */

export const BILL_ALLOC_INVOICE_SUBMODULE = "bill_allocations_invoice";
export const BILL_ALLOC_UNREGISTERED_SUBMODULE = "bill_allocations_unregistered";
export const BILL_ALLOC_UNREGISTERED_BIND = "bill_allocations_unregistered_split";
export const BILL_ALLOC_UNREGISTERED_BASE_KEY = "_bill_alloc_unregistered_base";
export const VENDOR_BILL_ALLOC_PURCHASE_SUBMODULE = "vendor_bill_allocations_purchase";
export const VENDOR_BILL_ALLOC_UNREGISTERED_SUBMODULE =
  "vendor_bill_allocations_unregistered";
export const VENDOR_BILL_ALLOC_UNREGISTERED_BIND =
  "vendor_bill_allocations_unregistered_split";
export const VENDOR_BILL_ALLOC_UNREGISTERED_BASE_KEY =
  "_vendor_bill_alloc_unregistered_base";
export const BILL_WISE_RELEASE_UNREGISTERED_SUBMODULE = "bill_wise_release_unregistered";
export const BILL_WISE_RELEASE_UNREGISTERED_BIND =
  "bill_wise_release_unregistered_split";
export const BILL_WISE_RELEASE_UNREGISTERED_BASE_KEY =
  "_bill_wise_release_unregistered_base";
export const VENDOR_BILL_WISE_RELEASE_UNREGISTERED_SUBMODULE =
  "vendor_bill_wise_release_unregistered";
export const VENDOR_BILL_WISE_RELEASE_UNREGISTERED_BIND =
  "vendor_bill_wise_release_unregistered_split";
export const VENDOR_BILL_WISE_RELEASE_UNREGISTERED_BASE_KEY =
  "_vendor_bill_wise_release_unregistered_base";
export const BILL_ALLOC_RECEIPT_FIELD = "drp_unregistered_receipt";
export const VENDOR_BILL_ALLOC_PAYMENT_FIELD = "drp_unregistered_payment";

export type BillAllocationModuleKeys = {
  unregisteredName: string;
  unregisteredBind: string;
  unregisteredBaseKey: string;
};

export const BILL_ALLOC_MODULE_KEYS: BillAllocationModuleKeys = {
  unregisteredName: BILL_ALLOC_UNREGISTERED_SUBMODULE,
  unregisteredBind: BILL_ALLOC_UNREGISTERED_BIND,
  unregisteredBaseKey: BILL_ALLOC_UNREGISTERED_BASE_KEY,
};

export const BILL_WISE_RELEASE_MODULE_KEYS: BillAllocationModuleKeys = {
  unregisteredName: BILL_WISE_RELEASE_UNREGISTERED_SUBMODULE,
  unregisteredBind: BILL_WISE_RELEASE_UNREGISTERED_BIND,
  unregisteredBaseKey: BILL_WISE_RELEASE_UNREGISTERED_BASE_KEY,
};

export const VENDOR_BILL_ALLOC_MODULE_KEYS: BillAllocationModuleKeys = {
  unregisteredName: VENDOR_BILL_ALLOC_UNREGISTERED_SUBMODULE,
  unregisteredBind: VENDOR_BILL_ALLOC_UNREGISTERED_BIND,
  unregisteredBaseKey: VENDOR_BILL_ALLOC_UNREGISTERED_BASE_KEY,
};

export const VENDOR_BILL_WISE_RELEASE_MODULE_KEYS: BillAllocationModuleKeys = {
  unregisteredName: VENDOR_BILL_WISE_RELEASE_UNREGISTERED_SUBMODULE,
  unregisteredBind: VENDOR_BILL_WISE_RELEASE_UNREGISTERED_BIND,
  unregisteredBaseKey: VENDOR_BILL_WISE_RELEASE_UNREGISTERED_BASE_KEY,
};

export const resolveBillAllocationModuleKeys = (
  config?: { name?: string; BindValue?: string; lookupName?: string },
  formData?: Record<string, any>
): BillAllocationModuleKeys => {
  const bindValue = (config as { BindValue?: string })?.BindValue ?? "";
  const name = config?.name ?? "";
  if (
    name === "vendor_bill_wise_release_unregistered" ||
    bindValue === VENDOR_BILL_WISE_RELEASE_UNREGISTERED_BIND ||
    bindValue === "vendor_bill_wise_release_purchase_split" ||
    (formData &&
      (VENDOR_BILL_WISE_RELEASE_UNREGISTERED_BIND in formData ||
        "vendor_bill_wise_release_purchase_split" in formData))
  ) {
    return VENDOR_BILL_WISE_RELEASE_MODULE_KEYS;
  }
  if (
    name === "vendor_bill_allocations_unregistered" ||
    bindValue === VENDOR_BILL_ALLOC_UNREGISTERED_BIND ||
    bindValue === "vendor_bill_allocations_purchase_split" ||
    (formData &&
      (VENDOR_BILL_ALLOC_UNREGISTERED_BIND in formData ||
        "vendor_bill_allocations_purchase_split" in formData))
  ) {
    return VENDOR_BILL_ALLOC_MODULE_KEYS;
  }
  if (
    name === "bill_wise_release_unregistered" ||
    bindValue === BILL_WISE_RELEASE_UNREGISTERED_BIND ||
    bindValue === "bill_wise_release_invoice_split" ||
    (formData &&
      (BILL_WISE_RELEASE_UNREGISTERED_BIND in formData ||
        "bill_wise_release_invoice_split" in formData))
  ) {
    return BILL_WISE_RELEASE_MODULE_KEYS;
  }
  return BILL_ALLOC_MODULE_KEYS;
};

export const parseAllocationNumber = (value: unknown): number => {
  const n = parseFloat(String(value ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? n : 0;
};

export const roundMoney = (n: number): number =>
  Math.round((n + Number.EPSILON) * 100) / 100;

export const resolveReceiptRawItem = (
  row: Record<string, any>,
  receiptField: string = BILL_ALLOC_RECEIPT_FIELD
): Record<string, any> | null => {
  const key = `_${receiptField}_selectedOption`;
  const selected = row[key];
  if (selected && typeof selected === "object") {
    return selected as Record<string, any>;
  }
  return null;
};

/** Invoice row due (never use total_amount). */
export const getRowDueAmount = (row: Record<string, any>): number =>
  parseAllocationNumber(
    row.txt_due_amount ?? row.due_amount ?? row.txt_due ?? 0
  );

export const getLedgerIdFromInvoiceRow = (
  row: Record<string, any>
): string =>
  String(
    row.ledger_unregistered_id ??
      row[VENDOR_BILL_ALLOC_PAYMENT_FIELD] ??
      row.drp_unregistered_payment ??
      row[BILL_ALLOC_RECEIPT_FIELD] ??
      row.drp_unregistered_receipt ??
      ""
  ).trim();

export const getBillDocumentNoFromRow = (row: Record<string, any>): string =>
  String(
    row.txt_purchase_no ??
      row.purchase_no ??
      row.txt_invoice_no ??
      row.invoice_no ??
      ""
  ).trim();

const ledgerRowId = (row: Record<string, any>): string =>
  String(row.id ?? row.ledger_unregistered_id ?? row.receipt_id ?? "");

/** Ledger row from stamped unregistered base (full balance, not preview-depleted). */
export const findUnregisteredBaseRow = (
  ledgerId: string,
  formData?: Record<string, any>,
  moduleKeys: BillAllocationModuleKeys = BILL_ALLOC_MODULE_KEYS
): Record<string, any> | null => {
  if (!ledgerId || !formData) return null;
  const baseKeyRows =
    (formData[moduleKeys.unregisteredBaseKey] as Record<string, any>[]) || [];
  const fromBase = baseKeyRows.find((r) => ledgerRowId(r) === String(ledgerId));
  if (fromBase) return fromBase;
  const bindRows =
    (formData[moduleKeys.unregisteredBind] as Record<string, any>[]) || [];
  return bindRows.find((r) => ledgerRowId(r) === String(ledgerId)) ?? null;
};

/**
 * Full unregistered balance for a receipt (never the preview-depleted bind amount).
 * Falls back to invoice row caps when the stamped base is not on formData yet.
 */
export const getLedgerOriginalUnregisteredAmount = (
  ledgerId: string,
  formData?: Record<string, any>,
  invoiceRows?: Record<string, any>[],
  moduleKeys: BillAllocationModuleKeys = BILL_ALLOC_MODULE_KEYS
): number => {
  if (!ledgerId) return 0;

  const readFromGridRows = (rows: Record<string, any>[]): number => {
    for (const row of rows) {
      if (ledgerRowId(row) !== String(ledgerId)) continue;
      const stamped = parseAllocationNumber(row.unregistered_amount_original);
      if (stamped > 0) return stamped;
    }
    for (const row of rows) {
      if (ledgerRowId(row) !== String(ledgerId)) continue;
      if (
        row.unregistered_amount_original !== undefined &&
        row.unregistered_amount_original !== null &&
        row.unregistered_amount_original !== ""
      ) {
        continue;
      }
      const firstLoad = parseAllocationNumber(
        row.unregistered_amount ?? row.txt_unregistered_amount
      );
      if (firstLoad > 0) return firstLoad;
    }
    return 0;
  };

  let original = 0;
  if (formData) {
    const baseKeyRows =
      (formData[moduleKeys.unregisteredBaseKey] as Record<string, any>[]) ||
      [];
    original = readFromGridRows(baseKeyRows);
    if (original <= 0) {
      const bindRows =
        (formData[moduleKeys.unregisteredBind] as Record<string, any>[]) ||
        [];
      original = readFromGridRows(bindRows);
    }
  }

  if (original <= 0 && invoiceRows?.length) {
    for (const invRow of invoiceRows) {
      if (getLedgerIdFromInvoiceRow(invRow) !== String(ledgerId)) continue;
      const receipt = resolveReceiptRawItem(invRow);
      const fromReceipt =
        receipt != null
          ? parseAllocationNumber(
              receipt.unregistered_amount ?? receipt.txt_unregistered_amount
            )
          : 0;
      const fromRow = parseAllocationNumber(
        invRow.unregistered_amount_original ?? invRow.txt_unregistered_amount_cap
      );
      const cap = fromReceipt > 0 ? fromReceipt : fromRow;
      if (cap > original) original = cap;
    }
  }

  return original;
};

/** Original unregistered balance for the selected receipt (before this row's edit). */
export const getRowUnregisteredCap = (
  row: Record<string, any>,
  rawReceipt?: Record<string, any> | null,
  formData?: Record<string, any>,
  invoiceRows?: Record<string, any>[],
  moduleKeys: BillAllocationModuleKeys = BILL_ALLOC_MODULE_KEYS
): number => {
  const ledgerId =
    String(
      rawReceipt?.id ??
        rawReceipt?.value ??
        getLedgerIdFromInvoiceRow(row) ??
        ""
    ).trim();

  if (rawReceipt != null) {
    const receiptLedger = String(
      rawReceipt.id ?? rawReceipt.value ?? rawReceipt.ledger_unregistered_id ?? ""
    ).trim();
    const fromReceipt = parseAllocationNumber(
      rawReceipt.unregistered_amount ?? rawReceipt.txt_unregistered_amount
    );
    if (fromReceipt > 0 && (!ledgerId || receiptLedger === ledgerId)) {
      return fromReceipt;
    }
  }

  if (ledgerId && formData) {
    const fromLedger = getLedgerOriginalUnregisteredAmount(
      ledgerId,
      formData,
      invoiceRows,
      moduleKeys
    );
    if (fromLedger > 0) return fromLedger;
  }

  const fromRow = parseAllocationNumber(
    row.unregistered_amount_original ?? row.txt_unregistered_amount_cap
  );
  if (fromRow > 0) return fromRow;

  const receipt = resolveReceiptRawItem(row);
  if (!receipt) return 0;
  return parseAllocationNumber(
    receipt.unregistered_amount ?? receipt.txt_unregistered_amount
  );
};

/** Remaining unregistered for a ledger after other invoice rows' allocations. */
export const getAvailableUnregisteredForLedger = (
  ledgerId: string,
  formData: Record<string, any>,
  invoiceRows: Record<string, any>[],
  excludeRowIndex?: number,
  moduleKeys: BillAllocationModuleKeys = BILL_ALLOC_MODULE_KEYS
): number => {
  if (!ledgerId) return 0;
  const original = getLedgerOriginalUnregisteredAmount(
    ledgerId,
    formData,
    invoiceRows,
    moduleKeys
  );
  let allocatedElsewhere = 0;
  invoiceRows.forEach((invRow, idx) => {
    if (excludeRowIndex !== undefined && idx === excludeRowIndex) return;
    if (getLedgerIdFromInvoiceRow(invRow) !== ledgerId) return;
    allocatedElsewhere += parseAllocationNumber(
      invRow.txt_amount ?? invRow.amount
    );
  });
  return roundMoney(Math.max(0, original - allocatedElsewhere));
};

/**
 * Max allocate = min(invoice due, available unregistered for receipt).
 * When unregistered > due → cap is due; when unregistered < due → cap is unregistered.
 */
export const computeMaxAllocateAmount = (
  row: Record<string, any>,
  rawReceipt: Record<string, any> | null | undefined,
  options?: {
    formData?: Record<string, any>;
    invoiceRows?: Record<string, any>[];
    rowIndex?: number;
    moduleKeys?: BillAllocationModuleKeys;
  }
): number => {
  const moduleKeys = options?.moduleKeys ?? BILL_ALLOC_MODULE_KEYS;
  const due = getRowDueAmount(row);
  const ledgerId =
    String(rawReceipt?.id ?? rawReceipt?.value ?? "").trim() ||
    getLedgerIdFromInvoiceRow(row);

  const receiptCap = getRowUnregisteredCap(
    row,
    rawReceipt ?? null,
    options?.formData,
    options?.invoiceRows,
    moduleKeys
  );
  let unregAvailable = receiptCap;

  if (options?.formData && ledgerId) {
    const pooled = getAvailableUnregisteredForLedger(
      ledgerId,
      options.formData,
      options.invoiceRows ?? [],
      options.rowIndex,
      moduleKeys
    );
    if (pooled > 0) {
      unregAvailable =
        receiptCap > 0
          ? roundMoney(Math.min(receiptCap, pooled))
          : pooled;
    }
  }

  if (due <= 0 && unregAvailable <= 0) return 0;
  if (unregAvailable <= 0) return 0;
  if (due <= 0) return unregAvailable;
  return roundMoney(Math.min(due, unregAvailable));
};

export const capAllocateAmountOnRow = (
  row: Record<string, any>,
  rawReceipt?: Record<string, any> | null,
  options?: {
    formData?: Record<string, any>;
    invoiceRows?: Record<string, any>[];
    rowIndex?: number;
    moduleKeys?: BillAllocationModuleKeys;
  }
): Record<string, any> => {
  const moduleKeys = options?.moduleKeys ?? BILL_ALLOC_MODULE_KEYS;
  const next = { ...row };
  const due = getRowDueAmount(next);
  const maxAllocate = computeMaxAllocateAmount(next, rawReceipt, options);
  let amount = parseAllocationNumber(next.txt_amount ?? next.amount);
  if (maxAllocate > 0) {
    amount = roundMoney(Math.min(Math.max(0, amount), maxAllocate));
  } else {
    amount = roundMoney(Math.max(0, amount));
  }

  const ledgerId =
    String(rawReceipt?.id ?? rawReceipt?.value ?? "").trim() ||
    getLedgerIdFromInvoiceRow(next);
  const poolBeforeThisRow =
    ledgerId && options?.formData
      ? getAvailableUnregisteredForLedger(
          ledgerId,
          options.formData,
          options.invoiceRows ?? [],
          options.rowIndex,
          moduleKeys
        )
      : getRowUnregisteredCap(
          next,
          rawReceipt ?? null,
          options?.formData,
          options?.invoiceRows,
          moduleKeys
        );

  next.txt_max_allocate = maxAllocate;
  next.txt_amount = amount;
  next.amount = amount;
  next.txt_due_after_allocation = roundMoney(Math.max(0, due - amount));
  next.txt_remaining_unregistered = roundMoney(
    Math.max(0, poolBeforeThisRow - amount)
  );
  return next;
};

/** Apply receipt selection: set allocation amount and derived display fields. */
export const applyReceiptSelectionToInvoiceRow = (
  row: Record<string, any>,
  rawReceipt: Record<string, any> | null,
  options?: {
    formData?: Record<string, any>;
    invoiceRows?: Record<string, any>[];
    rowIndex?: number;
    moduleKeys?: BillAllocationModuleKeys;
  }
): Record<string, any> => {
  const moduleKeys = options?.moduleKeys ?? BILL_ALLOC_MODULE_KEYS;
  const next = { ...row };
  if (!rawReceipt) {
    return next;
  }

  const ledgerId = rawReceipt.id ?? rawReceipt.value ?? "";
  const due = getRowDueAmount(next);
  const unregOriginal = getRowUnregisteredCap(
    next,
    rawReceipt,
    options?.formData,
    options?.invoiceRows,
    moduleKeys
  );
  const maxAllocate = computeMaxAllocateAmount(
    {
      ...next,
      unregistered_amount_original: unregOriginal,
      txt_unregistered_amount_cap: unregOriginal,
      [BILL_ALLOC_RECEIPT_FIELD]: ledgerId ? String(ledgerId) : "",
      ledger_unregistered_id: ledgerId ? String(ledgerId) : "",
    },
    rawReceipt,
    options
  );
  const allocate = roundMoney(
    maxAllocate > 0 ? maxAllocate : 0
  );

  next[BILL_ALLOC_RECEIPT_FIELD] = ledgerId ? String(ledgerId) : "";
  next.ledger_unregistered_id = ledgerId ? String(ledgerId) : "";
  next.txt_reciept_no =
    rawReceipt.reciept_no ?? rawReceipt.receipt_no ?? next.txt_reciept_no ?? "";
  const entrySource = String(rawReceipt.entry_source ?? "").trim();
  if (entrySource) {
    next.entry_source = entrySource;
  }
  next.unregistered_amount_original = unregOriginal;
  next.txt_unregistered_amount_cap = unregOriginal;
  next.txt_max_allocate = maxAllocate;
  next.txt_amount = allocate;
  next.amount = allocate;
  next.txt_due_after_allocation = roundMoney(Math.max(0, due - allocate));
  const poolBeforeThisRow =
    ledgerId && options?.formData
      ? getAvailableUnregisteredForLedger(
          String(ledgerId),
          options.formData,
          options.invoiceRows ?? [],
          options.rowIndex,
          moduleKeys
        )
      : unregOriginal;
  next.txt_remaining_unregistered = roundMoney(
    Math.max(0, poolBeforeThisRow - allocate)
  );

  return next;
};

/** Ledger ids that need recalc (current + previous receipt when user switches voucher). */
export const collectBillAllocationLedgersToRecalc = (
  invoiceRows: Record<string, any>[],
  options?: {
    changedLedgerId?: string;
    previousLedgerId?: string;
    changedRowIndex?: number;
  }
): Set<string> => {
  const ledgers = new Set<string>();
  const add = (id?: string) => {
    const trimmed = String(id ?? "").trim();
    if (trimmed) ledgers.add(trimmed);
  };
  add(options?.changedLedgerId);
  add(options?.previousLedgerId);
  if (options?.changedRowIndex !== undefined) {
    add(getLedgerIdFromInvoiceRow(invoiceRows[options.changedRowIndex] ?? {}));
  }
  return ledgers;
};

/** Recalculate invoice rows that share a receipt ledger (same or different receipts per row). */
export const recalcBillAllocationInvoiceGrid = (
  invoiceRows: Record<string, any>[],
  formData: Record<string, any>,
  options?: {
    changedLedgerId?: string;
    previousLedgerId?: string;
    changedRowIndex?: number;
    moduleKeys?: BillAllocationModuleKeys;
  }
): Record<string, any>[] => {
  const moduleKeys = options?.moduleKeys ?? BILL_ALLOC_MODULE_KEYS;
  const ledgersToRecalc = collectBillAllocationLedgersToRecalc(
    invoiceRows,
    options
  );

  const rows = invoiceRows.map((r) => ({ ...r }));
  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    const ledgerId = getLedgerIdFromInvoiceRow(rows[rowIndex]);
    if (!ledgerId) continue;
    if (ledgersToRecalc.size > 0 && !ledgersToRecalc.has(ledgerId)) {
      continue;
    }
    const rawReceipt =
      resolveReceiptRawItem(rows[rowIndex]) ||
      findUnregisteredBaseRow(ledgerId, formData, moduleKeys);
    rows[rowIndex] = capAllocateAmountOnRow(rows[rowIndex], rawReceipt, {
      formData,
      invoiceRows: rows,
      rowIndex,
      moduleKeys,
    });
  }
  return rows;
};

const receiptNoAllocationKey = (receiptNo: string): string =>
  `reciept_no:${receiptNo}`;

/** Sum allocation amounts per ledger id (and receipt no fallback) across invoice rows. */
export const sumAllocationsByLedgerId = (
  invoiceRows: Record<string, any>[]
): Record<string, number> => {
  const totals: Record<string, number> = {};
  for (const row of invoiceRows) {
    const ledgerId = getLedgerIdFromInvoiceRow(row);
    const amount = parseAllocationNumber(row.txt_amount ?? row.amount);
    if (amount <= 0) continue;
    if (ledgerId) {
      totals[ledgerId] = roundMoney((totals[ledgerId] || 0) + amount);
    }
    const rawReceipt = resolveReceiptRawItem(row);
    const receiptNo = String(
      row.txt_reciept_no ??
        row.reciept_no ??
        rawReceipt?.reciept_no ??
        rawReceipt?.receipt_no ??
        ""
    ).trim();
    if (receiptNo) {
      const receiptKey = receiptNoAllocationKey(receiptNo);
      totals[receiptKey] = roundMoney((totals[receiptKey] || 0) + amount);
    }
  }
  return totals;
};

/** Refresh unregistered grid balances after invoice allocations (UI preview). */
export const applyAllocationsToUnregisteredRows = (
  baseRows: Record<string, any>[],
  allocationsByLedgerId: Record<string, number>
): Record<string, any>[] => {
  return baseRows.map((row) => {
    const id = String(row.id ?? row.ledger_unregistered_id ?? "");
    const receiptNo = String(row.reciept_no ?? row.receipt_no ?? "").trim();
    const original = parseAllocationNumber(
      row.unregistered_amount_original ?? row.unregistered_amount
    );
    const allocated =
      allocationsByLedgerId[id] ||
      (receiptNo ? allocationsByLedgerId[receiptNoAllocationKey(receiptNo)] : 0) ||
      0;
    const remaining = roundMoney(Math.max(0, original - allocated));
    return {
      ...row,
      unregistered_amount_original: original,
      unregistered_amount: remaining,
      txt_unregistered_amount: remaining,
    };
  });
};

export const ensureUnregisteredOriginalAmounts = (
  rows: Record<string, any>[]
): Record<string, any>[] =>
  rows.map((row) => {
    const original = parseAllocationNumber(
      row.unregistered_amount_original ??
        row.unregistered_amount ??
        row.txt_unregistered_amount
    );
    const displayAmount = parseAllocationNumber(
      row.unregistered_amount ?? row.txt_unregistered_amount ?? original
    );
    return {
      ...row,
      unregistered_amount_original: original,
      unregistered_amount: displayAmount,
      txt_unregistered_amount: displayAmount,
    };
  });

/** Recalculate invoice row when allocation amount is edited manually. */
export const recalcInvoiceRowFromAmount = (
  row: Record<string, any>,
  options?: {
    formData?: Record<string, any>;
    invoiceRows?: Record<string, any>[];
    rowIndex?: number;
  }
): Record<string, any> => {
  const rawReceipt = resolveReceiptRawItem(row);
  return capAllocateAmountOnRow(row, rawReceipt, options);
};

const resolveVoucherLabelForLedger = (
  ledgerId: string,
  invoiceRows: Record<string, any>[],
  formData: Record<string, any>,
  moduleKeys: BillAllocationModuleKeys
): string => {
  const matchingRow = invoiceRows.find(
    (row) => getLedgerIdFromInvoiceRow(row) === ledgerId
  );
  if (matchingRow) {
    const receiptNo = String(
      matchingRow.txt_reciept_no ??
        matchingRow.reciept_no ??
        matchingRow.receipt_no ??
        ""
    ).trim();
    if (receiptNo) return receiptNo;
    const rawReceipt = resolveReceiptRawItem(matchingRow);
    const fromReceipt = String(
      rawReceipt?.reciept_no ?? rawReceipt?.receipt_no ?? ""
    ).trim();
    if (fromReceipt) return fromReceipt;
  }
  const baseRow = findUnregisteredBaseRow(ledgerId, formData, moduleKeys);
  if (baseRow) {
    const baseNo = String(
      baseRow.reciept_no ?? baseRow.receipt_no ?? ""
    ).trim();
    if (baseNo) return baseNo;
  }
  return ledgerId;
};

/** Block submit when the same receipt/voucher is over-allocated across invoice rows. */
export const validateBillAllocationReceiptPools = (
  invoiceRows: Record<string, any>[],
  formData: Record<string, any>,
  moduleKeys: BillAllocationModuleKeys = BILL_ALLOC_MODULE_KEYS
): string | null => {
  const activeRows = invoiceRows.filter(
    (row) => row.soft_delete !== 1 && row.soft_delete !== "1"
  );
  if (activeRows.length === 0) return null;

  const totals = sumAllocationsByLedgerId(activeRows);
  for (const [ledgerId, totalAlloc] of Object.entries(totals)) {
    if (ledgerId.startsWith("reciept_no:")) continue;
    if (totalAlloc <= 0) continue;

    const available = getLedgerOriginalUnregisteredAmount(
      ledgerId,
      formData,
      activeRows,
      moduleKeys
    );
    if (roundMoney(totalAlloc) <= roundMoney(available) + 0.009) continue;

    const voucherLabel = resolveVoucherLabelForLedger(
      ledgerId,
      activeRows,
      formData,
      moduleKeys
    );
    return (
      `Allocation total (${roundMoney(totalAlloc).toFixed(2)}) exceeds unregistered ` +
      `balance (${roundMoney(available).toFixed(2)}) for receipt/voucher ${voucherLabel}.`
    );
  }
  return null;
};

export const isBillAllocationInvoiceSubmodule = (config: {
  name?: string;
  billAllocationMode?: boolean;
  vendorBillAllocationMode?: boolean;
}): boolean =>
  Boolean(
    config.billAllocationMode ||
      config.vendorBillAllocationMode ||
      config.name === BILL_ALLOC_INVOICE_SUBMODULE ||
      config.name === VENDOR_BILL_ALLOC_PURCHASE_SUBMODULE ||
      config.name === "invoice_recivebles" ||
      config.name === "purchase_recivebles" ||
      config.name === "vendor_bill_allocations_purchase"
  );

export const isBillAllocationUnregisteredSubmodule = (config: {
  name?: string;
  lookupName?: string;
  BindValue?: string;
  billWiseReleaseMode?: boolean;
  vendorBillWiseReleaseMode?: boolean;
}): boolean => {
  if (config.billWiseReleaseMode || config.vendorBillWiseReleaseMode) return false;
  return (
    (config.lookupName === "customer_unregistered_receipts" &&
      config.name === "bill_allocations_unregistered") ||
    (config.lookupName === "vendor_unregistered_payments" &&
      config.name === "vendor_bill_allocations_unregistered") ||
    config.name === "bill_allocations_unregistered" ||
    config.name === "vendor_bill_allocations_unregistered"
  );
};

export const resolveBillAllocationReceiptField = (
  config?: { vendorBillAllocationMode?: boolean; lookupName?: string }
): string => {
  if (
    config?.vendorBillAllocationMode ||
    config?.lookupName === "vendor_unregistered_payments"
  ) {
    return VENDOR_BILL_ALLOC_PAYMENT_FIELD;
  }
  return BILL_ALLOC_RECEIPT_FIELD;
};

export const stampUnregisteredBaseRows = (
  rows: Record<string, any>[]
): Record<string, any>[] => ensureUnregisteredOriginalAmounts(rows);

export const syncBillAllocationUnregisteredPreview = (
  invoiceRows: Record<string, any>[],
  formData: Record<string, any>,
  onFormDataChange?: (name: string, value: any) => void,
  moduleKeys: BillAllocationModuleKeys = BILL_ALLOC_MODULE_KEYS
): void => {
  if (!onFormDataChange) return;
  const baseKeyRows =
    (formData[moduleKeys.unregisteredBaseKey] as Record<string, any>[]) || [];
  const base =
    baseKeyRows.length > 0
      ? baseKeyRows
      : (formData[moduleKeys.unregisteredBind] as Record<string, any>[]) ||
        [];
  const stampedBase = stampUnregisteredBaseRows(base).map((row) => {
    const id = ledgerRowId(row);
    const originalFromInvoices = getLedgerOriginalUnregisteredAmount(
      id,
      { [moduleKeys.unregisteredBaseKey]: base },
      invoiceRows,
      moduleKeys
    );
    const original = parseAllocationNumber(row.unregistered_amount_original);
    const resolvedOriginal =
      original > 0
        ? original
        : originalFromInvoices > 0
          ? originalFromInvoices
          : parseAllocationNumber(
              row.unregistered_amount ?? row.txt_unregistered_amount
            );
    return {
      ...row,
      unregistered_amount_original: resolvedOriginal,
    };
  });
  const allocations = sumAllocationsByLedgerId(invoiceRows);
  const preview = applyAllocationsToUnregisteredRows(stampedBase, allocations);
  // ComponentRenderer reads submodule name first, then bind — update both for live preview.
  onFormDataChange(moduleKeys.unregisteredBind, preview);
  if (
    moduleKeys.unregisteredName &&
    moduleKeys.unregisteredName !== moduleKeys.unregisteredBind
  ) {
    onFormDataChange(moduleKeys.unregisteredName, preview);
  }
};
